import {CreateForm} from '../../../../../pessoas/components/CreateForm'
import {useState} from 'react'
import {formatNumber} from '../../../../../../components/util'
import {formatDate} from '../../../../../explorer/components/common'

type Props = {
  data: any
  reportTemplateRef: any
  params?: {
    endereco?: string
    cep?: string
    number?: number
    name?: string
  }
}

export const TableTransacoes: React.FC<Props> = ({data, reportTemplateRef, params}) => {
  const [showCreate, setShowCreate] = useState(false)
  function CloseModalCreate() {
    setShowCreate(false)
  }

  if (!data) {
    return <></>
  }

  return (
    <div className='table-responsive'>
      <table className='table table-striped gs-7 ' ref={reportTemplateRef}>
        <thead>
          <tr className='fw-bolder text-muted'>
            <th className='min-w-50px'>Data transação</th>
            <th className='min-w-140px'>Natureza</th>
            <th className='min-w-140px'>Complemento</th>
            <th className='min-w-140px'>Valor</th>
            <th className='min-w-50px'>Proporção</th>
          </tr>
        </thead>
        <tbody>
          {data.itens.length === 0 ? (
            <tr>
              <td colSpan={5} className='text-center'>
                Nenhum registro encontrado
              </td>
            </tr>
          ) : (
            <></>
          )}
          {
            // eslint-disable-next-line array-callback-return
            data.itens.map((item, index) => {
              return (
                <tr key={index}>
                  <td>
                    <div className='d-flex align-items-center'>
                      <div className='d-flex justify-content-start flex-column'>
                        {formatDate(item.data_de_transacao)}
                      </div>
                    </div>
                  </td>
                  <td>{item.natureza_de_transacao}</td>
                  <td>{item.complemento === 'nan' ? '-' : item.complemento}</td>
                  <td>
                    {formatNumber(item.valor_de_transacao_declarado_pelo_contribuinte, 'currency')}
                  </td>
                  <td>{item.proporcao_transmitida_}</td>
                </tr>
              )
            })
          }
        </tbody>
      </table>
      {showCreate ? (
        <CreateForm
          origin='Imoveis'
          params={params}
          closeModal={CloseModalCreate}
          show={showCreate}
        />
      ) : (
        <></>
      )}
    </div>
  )
}
